import { render, staticRenderFns } from "./emailSettingsText.vue?vue&type=template&id=3e8801f5&scoped=true&"
import script from "./emailSettingsText.vue?vue&type=script&lang=js&"
export * from "./emailSettingsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8801f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
